import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from 'uuid';

import {
	Alignment,
	Button,
	Classes,
	Dialog,
	FormGroup,
	InputGroup,
	Intent,
	Navbar,
	Checkbox,
	NumericInput,
} from '@blueprintjs/core';

import TextWithTooltip from '../TextWithTooltip';
import { AppToaster }  from '../AppToaster';
import SimpleSuggest from '../SimpleSuggest';
import { MultiSelectFilter } from './ResultComponents';

class AddEditUser extends Component {
	constructor(props) {
		super(props);
		
		this.copyAccessRolesFromUser = this.copyAccessRolesFromUser.bind(this);
		
		this.state = {
			id_user:             props.item === null ? -1    : props.item.id_user,
			username:            props.item === null ? ''    : props.item.username,
			name:                props.item === null ? ''    : props.item.name,
			surname:             props.item === null ? ''    : props.item.surname,
			is_worker:           props.item === null ? false : props.item.is_worker,
			is_active:           props.item === null ? true  : props.item.is_active,
			password:            props.item === null ? ''    : (props.item.password ?? ''),
			operator_tax_number: props.item === null ? ''    : props.item.operator_tax_number,
			access_roles:        props.item === null ? []    : props.item.access_roles,
			is_foreigner:        props.item === null ? false : props.item.is_foreigner,
			data_retention_days: props.item === null ? {}    : props.item.data_retention_days,
			id_cash_registers:   props.item === null ? []    : props.item.id_cash_registers,
			validation_failed_fields: [],
			copy_from_id_user: null,
		};
	}
	
	copyAccessRolesFromUser() {
		if (this.state.copy_from_id_user === null) return;
		
		this.setState({
			access_roles: this.props.users[this.state.copy_from_id_user].access_roles,
			data_retention_days: this.props.users[this.state.copy_from_id_user].data_retention_days,
			copy_from_id_user: null,
		});
	}
	
	render() {
		const dropdownUsers = Object.values(this.props.users)
			.filter(x => x.username != 'admin' && x.id_user != this.state.id_user)
			.sort((a, b) => a.ord - b.ord)
			.map(x => ({ ...x, full_name: (x.name + ' ' + x.surname).trim() }));
		const dropdownUsersById = new Map(dropdownUsers.map(x => [ x.id_user, x ]));
		
		return <Dialog
			isOpen={true}
			usePortal={true}
			canOutsideClickClose={true}
			canEscapeKeyClose={true}
			onClose={() => this.props.closeAddEditItemDialog()}
			className='add-edit-channel-dialog' style={{ width: 900 }}>
			<div className='flex flex-col flex-grow'>
				<Navbar fixedToTop={false} className='bp5-dark'>
					<Navbar.Group>
						<Navbar.Heading>Dodaj / uredi uporabnika</Navbar.Heading>
					</Navbar.Group>
					<Navbar.Group align={Alignment.RIGHT}>
						<Button minimal={true} icon='cross' onClick={() => this.props.closeAddEditItemDialog()} />
					</Navbar.Group>
				</Navbar>
				<div className={Classes.DIALOG_BODY}>
					<div className='flex flex-1 flex-row flex-wrap'>
						<FormGroup
							labelFor='add-edit-channel-dialog--username'
							className={
								'w-2/4 box-border pr-2 ' +
								(this.state.validation_failed_fields.indexOf('username') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Uporabniško ime'
								tooltip='Uporabniško ime' />
							<InputGroup
								id='add-edit-channel-dialog--username'
								value={this.state.username}
								onChange={event => {
									this.setState({
										username: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--password'
							className={
								'w-2/4 box-border pl-2 ' +
								(this.state.validation_failed_fields.indexOf('password') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Geslo (če ostane prazno, se geslo ne spremeni)'
								tooltip='Geslo' />
							<InputGroup
								id='add-edit-channel-dialog--password'
								value={this.state.password}
								onChange={event => {
									this.setState({
										password: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--name'
							className={
								'w-2/4 box-border pr-2 ' +
								(this.state.validation_failed_fields.indexOf('name') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Ime'
								tooltip='Ime' />
							<InputGroup
								id='add-edit-channel-dialog--name'
								value={this.state.name}
								onChange={event => {
									this.setState({
										name: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--surname'
							className={
								'w-2/4 box-border pl-2 ' +
								(this.state.validation_failed_fields.indexOf('surname') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Priimek'
								tooltip='Priimek' />
							<InputGroup
								id='add-edit-channel-dialog--surname'
								value={this.state.surname}
								onChange={event => {
									this.setState({
										surname: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--operator_tax_number'
							className='w-2/4 box-border pr-2'>
							<TextWithTooltip
								label='Davčna številka'
								tooltip='Davčna številka' />
							<InputGroup
								id='add-edit-channel-dialog--operator_tax_number'
								value={this.state.operator_tax_number}
								onChange={event => {
									this.setState({
										operator_tax_number: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--cash-registers'
							className='w-2/4 box-border pl-2'>
							<TextWithTooltip
								label='Blagajne'
								tooltip='Blagajne' />
							<MultiSelectFilter
								empty_title    ='Izberi'
								value_field    ='id_cash_register'
								title_field    ='title'
								items          ={this.props.cash_registers}
								filtered_keys  ={this.state.id_cash_registers}
								displayFilter  ={x => true}
								displaySort    ={(a, b) => a.title.localeCompare(b.title)}
								onFilterChange ={values => this.setState({ id_cash_registers: values })}
								small          ={false}
								full_width     ={true}
								hide_close_button={true} />
						</FormGroup>
						<div className='flex flex-col flex-1'>
							<div className='flex flex-row space-x-2 mb-2'>
								<Checkbox checked={this.state.is_active} onChange={event => {
									this.setState({ is_active: event.target.checked });
								}}>Aktiven</Checkbox>
								<Checkbox checked={this.state.is_worker} onChange={event => {
									this.setState({ is_worker: event.target.checked });
								}}>Delavec</Checkbox>
								<Checkbox checked={this.state.is_foreigner} disabled={true} onChange={event => {
									this.setState({ is_foreigner: event.target.checked });
								}}>Tujec</Checkbox>
							</div>
							<div className='flex flex-row'>
								<div>Pravice</div>
								<div className='flex-1'></div>
								
								<div>
									<SimpleSuggest
										matchKeyName='full_name'
										valueKeyName='id_user'
										items={
											dropdownUsers
										}
										onItemSelect={item => {
											this.setState({
												copy_from_id_user: item.id_user,
											});
										}}
										selectedItem={this.state.copy_from_id_user === null ? null : dropdownUsersById.get(this.state.copy_from_id_user)}
										placeholder='Išči' />
								</div>
								<Button disabled={this.state.copy_from_id_user === null} onClick={this.copyAccessRolesFromUser}>
									Nastavi pravice iz uporabnika
								</Button>
							</div>
							<FormGroup
								labelFor='add-edit-user-dialog--access_roles'
								className='flex flex-col' style={{ flex: 1 }}>
								<Checkbox
									checked={this.state.access_roles.indexOf('main') !== -1}
									onChange={event => {
										const access_roles = this.state.access_roles.filter(x => x != 'main');
										if (event.target.checked) access_roles.push('main');
										this.setState({ access_roles });
									}}>
									Dostop - AssistPRO
								</Checkbox>
								<div className='grid grid-cols-3'>
									{[
										[
											{ role: 'dashboard', level: 0, title: 'Nadzorna plošča' },
											{ role: 'dashboard--notifications', level: 1, title: 'opomniki', data_retention: true },
											{ role: 'dashboard--check-in', level: 1, title: 'prijave' },
											{ role: 'dashboard--check-out', level: 1, title: 'odjave' },
											{ role: 'dashboard--todo', level: 1, title: 'TODO' },
										],
										
										[
											{ role: 'reservations', level: 0, title: 'Rezervacije' },
											{ role: 'reservations--list', level: 1, title: 'seznam' },
										],
										
										[
											{ role: 'business', level: 0, title: 'Poslovanje' },
											{ role: 'business--cash-invoices', level: 1, title: 'blag. računi', data_retention: true },
											{ role: 'business--business-invoices', level: 1, title: 'fakturiranje', data_retention: true },
											{ role: 'business--offers', level: 1, title: 'ponudbe', data_retention: true },
											{ role: 'business--invoices-book', level: 1, title: 'knjiga IR', data_retention: true },
											{ role: 'business--prepayment-book', level: 1, title: 'knjiga PA', data_retention: true },
										],
										
										[
											{ role: 'cash-register', level: 0, title: 'Blagajna' },
											{ role: 'cash-register--journals', level: 1, title: 'bl. dnevnik', data_retention: true },
											{ role: 'cash-register--documents', level: 1, title: 'blagajniški dokumenti', data_retention: true },
											{ role: 'cash-register--recapitulation', level: 1, title: 'rekapitulacija blagajne' },
										],
										
										[
											{ role: 'stock', level: 0, title: 'Zaloge' },
											{ role: 'stock--acquisitions', level: 1, title: 'prevzem', data_retention: true },
											{ role: 'stock--delivery-notes', level: 1, title: 'dobavnica', data_retention: true },
											{ role: 'stock--inventory', level: 1, title: 'stanje zalog' },
										],
										
										[
											{ role: 'etourism', level: 0, title: 'Poročanje - e-Turizem' },
											{ role: 'etourism--guest-book', level: 1, title: 'prijava/knjiga gostov' },
											{ role: 'etourism--monthly-statistics', level: 1, title: 'mesečna statistika' },
											{ role: 'etourism--tourist-taxes', level: 1, title: 'turistična taksa' },
										],
										
										[
											{ role: 'reports', level: 0, title: 'Poročila' },
											{ role: 'reports--reservations-report', level: 1, title: 'rezervacije' },
											{ role: 'reports--activity-reservations', level: 1, title: 'artikli/storitve', data_retention: true },
											{ role: 'reports--cash-registers', level: 1, title: 'blagajna' },
											[ 'test', 'sr' ].indexOf(this.props.client) == -1 ? null :
												{ role: 'reports--realization', level: 1, title: 'realizacija', data_retention: true },
										],
										
										[
											{ role: 'code-tables', level: 0, title: 'Šifranti' },
											{ role: 'code-tables--customers', level: 1, title: 'stranke' },
											{ role: 'code-tables--customers--export-to-excel', level: 2, title: 'izvoz v Excel' },
											{ role: 'code-tables--items-and-services', level: 1, title: 'artikli/storitve' },
											{ role: 'code-tables--items-and-services--export-to-excel', level: 2, title: 'izvoz v Excel' },
											{ role: 'code-tables--users', level: 1, title: 'uporabniki' },
										],
										
										[
											{ role: 'settings', level: 0, title: 'Nastavitve' },
											{ role: 'settings--general', level: 1, title: 'splošne nastavitve' },
											{ role: 'settings--reports', level: 1, title: 'izpisi dokumentov' },
											{ role: 'settings--print', level: 1, title: 'tiskanje' },
											{ role: 'settings--parameters', level: 1, title: 'parametri' },
										],
									].filter(x => x !== null).map((y, idx) => <div className='pb-2'>{y.filter(a => a !== null).map((x, idx2) => x.role == ''
										? <div key={idx + '--' + idx2} className={x.level == 0 ? '' : ('ml-' + (2 * x.level))}>{ x.title }</div>
										: <div className='flex flex-row justify-between'>
											<Checkbox
												key={x.role}
												checked={this.state.access_roles.indexOf(x.role) !== -1}
												className={x.level == 0 ? '' : ('ml-' + (4 * x.level))}
												onChange={event => {
													let access_roles = this.state.access_roles.filter(z => z != x.role);
													if (event.target.checked) {
														access_roles.push(x.role);
													}
													this.setState({ access_roles });
												}}>
												{ x.title }
											</Checkbox>
											<div className='ml-2 mr-2 pt-1 w-20'>{x.data_retention !== true
												? null
												: <FormGroup inline={true}>
													<NumericInput
														fill={true}
														small
														size={'small'}
														value={this.state.data_retention_days[x.role] ?? ''}
														min={0}
														minorStepSize={1}
														placeholder='št. dni'
														onValueChange={val => {
															const newVal = { ...this.state.data_retention_days };
															newVal[x.role] = val;
															this.setState({ data_retention_days: newVal });
														}} />
												</FormGroup>}</div>
										</div>)}</div>
									)}
								</div>
								
								{[ 'test', 'sr', 'va', 'sags' ].indexOf(this.props.client) == -1 ? null : <>
									<div className='pb-4'></div>
									
									<div>
										{[
											[ { role: 'doc-admin', level: 0, title: 'Dostop - evidenca (polni dostop)' } ],
											[],
											[
												{ role: 'doc-entry',                  level: 0, title: 'Dostop - evidenca (vpis)'                },
												{ role: 'doc-entry-edit-bonus-1',     level: 1, title: 'Dostop - evidenca (vpis, dodatek I.)'    },
												{ role: 'doc-entry-edit-bonus-2',     level: 1, title: 'Dostop - evidenca (vpis, dodatek II.)'   },
												{ role: 'doc-entry-edit-bonus-3',     level: 1, title: 'Dostop - evidenca (vpis, dodatek III.)'  },
												{ role: 'doc-entry-edit-bonus-extra', level: 1, title: 'Dostop - evidenca (vpis, dodatek Extra)' },
											],
											[],
											[ { role: 'doc-statistics',           level: 0, title: 'Dostop - evidenca (statistika)'   } ],
											[ { role: 'doc-user-statistics',      level: 0, title: 'Dostop - evidenca (obračun)'      } ],
											[ { role: 'doc-analytics',            level: 0, title: 'Dostop - evidenca (analitika)'    } ],
											[ { role: 'doc-operative-activities', level: 0, title: 'Dostop - evidenca (operativa)', data_retention: true } ],
											[ { role: 'doc-settings',             level: 0, title: 'Dostop - evidenca (nastavitve)'   } ],
										].map((y, idx) => <div>{
											y.map((x, idx2) => <Checkbox
												key={x.role}
												checked={this.state.access_roles.indexOf(x.role) !== -1}
												className={x.level == 0 ? '' : ('ml-' + (4 * x.level))}
												onChange={event => {
													if (x.role == 'doc-admin') {
														let access_roles = this.state.access_roles.filter(z => z != 'doc-admin');
														if (event.target.checked) {
															access_roles.push('doc-admin');
															
															// remove roles superseded by this one
															access_roles = access_roles.filter(z => {
																return [
																	'doc',
																	'doc-entry',
																	'doc-entry-edit-bonus-1',
																	'doc-entry-edit-bonus-2',
																	'doc-entry-edit-bonus-3',
																	'doc-entry-edit-bonus-extra',
																	'doc-statistics',
																	'doc-user-statistics',
																	'doc-analytics',
																	'doc-operative-activities',
																	'doc-settings',
																].indexOf(z) === -1;
															});
														}
														this.setState({ access_roles });
													}
													else {
														let access_roles = this.state.access_roles.filter(z => z != x.role);
														if (event.target.checked) {
															access_roles.push(x.role);
															
															// remove admin role
															access_roles = access_roles.filter(z => z != 'doc-admin');
														}
														this.setState({ access_roles });
													}
												}}>
												{ x.title }
											</Checkbox>)}</div>
										)}
									</div>
									<Checkbox
										className='pt-4'
										checked={this.state.access_roles.indexOf('doc-worker') !== -1}
										onChange={event => {
											const access_roles = this.state.access_roles.filter(x => x != 'doc-worker');
											if (event.target.checked) access_roles.push('doc-worker');
											this.setState({ access_roles });
										}}>
										Dostop - evidenca (mobilna)
									</Checkbox>
								</>}
							</FormGroup>
						</div>
					</div>
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							minimal={true}
							onClick={() => this.props.closeAddEditItemDialog()}>
							Prekliči
						</Button>
						<Button
							intent={Intent.PRIMARY}
							onClick={() => {
								const new_item = {
									id_user:             this.state.id_user,
									username:            this.state.username,
									name:                this.state.name,
									surname:             this.state.surname,
									is_worker:           this.state.is_worker,
									is_active:           this.state.is_active,
									password:            this.state.password,
									operator_tax_number: this.state.operator_tax_number,
									access_roles:        this.state.access_roles,
									is_foreigner:        this.state.is_foreigner,
									data_retention_days: this.state.data_retention_days,
									id_cash_registers:   this.state.id_cash_registers,
								};
								
								// validate missing/empty fields
								const validation_failed_fields       = [];
								const validation_failed_field_titles = [];
								
								if (new_item.username.length == 0) {
									validation_failed_fields.push('username');
									validation_failed_field_titles.push('oznaka');
								}
								if (new_item.name.length == 0) {
									validation_failed_fields.push('name');
									validation_failed_field_titles.push('ime');
								}
								if (new_item.surname.length == 0) {
									validation_failed_fields.push('surname');
									validation_failed_field_titles.push('priimek');
								}
								if (new_item.password.length == 0 && new_item.id_user === -1) {
									validation_failed_fields.push('password');
									validation_failed_field_titles.push('geslo');
								}
								
								this.setState({ validation_failed_fields });
								
								if (validation_failed_fields.length > 0) {
									AppToaster.show({
										message: <div>
											Za shranjevanje, izpolnite vsaj polja:
											<br />
											{validation_failed_field_titles.map(title => <div key={title}>{'• ' + title}</div>)}
										</div>,
										intent: 'danger',
										icon: 'issue'
									});
									return;
								}
								
								// save item
								if (new_item.id_user === -1) {
									new_item.id_user = uuid.v4();
								}
								this.props.closeAddEditItemDialog(new_item);
							}}>
							Shrani in zapri
						</Button>
					</div>
				</div>
			</div>
		</Dialog>;
	}
}
AddEditUser.propTypes = {
	closeAddEditItemDialog: PropTypes.func,
	item: PropTypes.object,
};

function mapStateToProps(state) {
	return {
		client: state.ConstantsSlice.client,
		users: state.UserSlice.users,
		cash_registers: state.CashRegisterSlice.cash_registers,
	};
}

export default connect(mapStateToProps)(AddEditUser);
